import { memo } from 'react'

import HomePage from './HomePage'

const HomePageComponent = memo(HomePage)

export default HomePageComponent
